import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['amount', 'submit', 'help'];
  static values = { feeApplies: Boolean, minCents: Number };

  connect() {
    this.#refresh();
  }

  validate() {
    this.#refresh();
  }

  #refresh() {
    if (!this.feeAppliesValue) return;

    const valid = this.#amountInCents >= this.minCentsValue;
    this.submitTarget.disabled = !valid;
    this.helpTarget.classList.toggle('d-none', valid || this.#isEmpty);
  }

  get #isEmpty() {
    return this.amountTarget.value.trim() === '';
  }

  get #amountInCents() {
    const value = parseFloat(this.amountTarget.value);

    return Number.isNaN(value) ? 0 : Math.round(value * 100);
  }
}
